import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "aria-label": "Main navigation",
  class: "py-4 px-4 md:px-12 md:py-8 uppercase flex flex-row justify-between items-center text-primary md:p-4 tracking-[0.15rem]"
}
const _hoisted_2 = { class: "flex-grow text-sm md:text-base justify-between flex flex-row items-center md:flex-grow-0" }
const _hoisted_3 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = { class: "ml-2 mr-1 flex md:gap-2 flex-shrink-0 items-center justify-between" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center w-[2rem] flex-shrink-0"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 0,
  class: "absolute top-[-0.65rem] md:top-[-0.45rem] right-[-0.4rem] md:right-[-0.2rem] h-5 w-5 text-amber-500 dark:text-yellow-400",
  "aria-hidden": "true"
}
const _hoisted_9 = { class: "sr-only" }
const _hoisted_10 = { class: "md:hidden" }
const _hoisted_11 = { class: "h-full flex flex-col justify-center items-center" }
const _hoisted_12 = { "aria-label": "Mobile navigation" }
const _hoisted_13 = { class: "uppercase tracking-[0.15rem] max-w-xl text-2xl flex flex-col items-center gap-6" }


export default /*@__PURE__*/_defineComponent({
  __name: 'TheSiteHeader',
  async setup(__props) {

let __temp: any, __restore: any

const config = useRuntimeConfig()
const redirect = import.meta.dev
  ? `&redirect_uri=http://localhost:3000/auth/github`
  : ''
const loginURL = `https://github.com/login/oauth/authorize?client_id=${config.public.githubClientId}${redirect}&scope=read:org`

const mobileMenuRef = ref<HTMLElement | null>(null)
const showMenu = ref(false)

const { data: currentLocation } = (
  ([__temp,__restore] = _withAsyncContext(() => useApiFetch('/api/current-location', {
  transform: location => ({
    area: location!.area,
    flagEmoji: location!.flagEmoji,
  }),
}))),
  __temp = await __temp,
  __restore(),
  __temp
)

const showAdminLink = ref(false)
onMounted(() => {
  try {
    showAdminLink.value = localStorage.getItem('admin-visited') === '1'
  }
  catch {
    // storage unavailable (private browsing etc.)
  }
})

const menu = computed(() => [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Talks',
    path: '/talks',
  },
  {
    name: 'Projects',
    path: '/projects',
  },
  {
    name: 'Uses',
    path: '/uses',
  },
  {
    name: 'Blog',
    path: '/blog',
  },
  ...(showAdminLink.value ? [{ name: 'Admin', path: '/admin' }] : []),
])

useRouter().afterEach(() => {
  mobileMenuRef.value?.hidePopover()
})

function onPopoverToggle (event: ToggleEvent) {
  const isOpen = event.newState === 'open'
  showMenu.value = isOpen
  document.body.classList.toggle('overflow-hidden', isOpen)
}

return (_ctx: any,_cache: any) => {
  const _component_NuxtLink = _resolveComponent("NuxtLink")!
  const _component_ToggleColorMode = _resolveComponent("ToggleColorMode")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createVNode(_component_NuxtLink, {
          class: _normalizeClass(["underlined-link mr-6 py-2", {
            'not-[:hover,:focus,:active]:after:border-transparent':
              _ctx.$route.path !== '/',
          }]),
          to: "/"
        }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createTextVNode(" Daniel Roe ", -1)),
            (_unref(currentLocation)?.flagEmoji)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, " is currently in " + _toDisplayString(_unref(currentLocation).area), 1),
                  _createTextVNode(" " + _toDisplayString(_unref(currentLocation).flagEmoji), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu).slice(1), (link) => {
        return (_openBlock(), _createElementBlock("li", {
          key: link.name
        }, [
          _createVNode(_component_NuxtLink, {
            class: _normalizeClass(["underlined-link hidden md:inline-block px-2 py-2 hover:text-primary active:text-primary focus:text-primary transition-colors", {
              'not-[:hover,:focus,:active]:after:border-transparent text-muted':
                _ctx.$route.path !== link.path,
            }]),
            to: link.path
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.name), 1)
            ]),
            _: 2
          }, 1032, ["class", "to"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.$auth.status === 'pending')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", {
              class: "h-6 w-6 i-svg-spinners:90-ring-with-bg",
              "aria-hidden": "true"
            }, null, -1),
            _createElementVNode("span", { class: "sr-only" }, " Loading ", -1)
          ]))]))
        : (_ctx.$auth.status === 'logged-out')
          ? (_openBlock(), _createBlock(_component_NuxtLink, {
              key: 1,
              to: loginURL,
              class: "p-1 w-[2rem] flex-shrink-0 border-transparent border-2 border-solid hover:border-primary active:border-primary rounded-full leading-none f-ring",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$auth.status = 'pending'))
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("span", {
                  class: "h-5 w-5 i-ri:login-circle-line",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", { class: "sr-only" }, " Login ", -1)
              ]))]),
              _: 1
            }))
          : (_ctx.$auth.status === 'logged-in')
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "relative flex-shrink-0 w-[2rem] rounded-full f-ring",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.$auth.logout && _ctx.$auth.logout(...args)))
              }, [
                _createElementVNode("img", {
                  class: _normalizeClass(["h-8 w-8 md:h-6 md:w-6 rounded-full", { 'border-[1px] border-amber-500 dark:border-yellow-400': _ctx.$auth.user.sponsor }]),
                  src: _ctx.$auth.user.avatar,
                  alt: `${_ctx.$auth.user.name}'s avatar`
                }, null, 10, _hoisted_7),
                (_ctx.$auth.user.sponsor)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("span", { class: "i-ri:star-fill border border-solid border-gray-200 dark:border-gray-800" }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_9, " Log out " + _toDisplayString(_ctx.$auth.user.name), 1)
              ]))
            : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _cache[7] || (_cache[7] = _createElementVNode("button", {
          type: "button",
          class: "ml-4 rounded f-ring",
          popovertarget: "mobile-menu"
        }, [
          _createElementVNode("span", {
            class: "menu-icon h-8 w-8 md:h-6 md:w-6 i-ri:add-line",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", { class: "sr-only" }, " Open mobile navigation menu ")
        ], -1)),
        _createElementVNode("div", {
          id: "mobile-menu",
          ref_key: "mobileMenuRef",
          ref: mobileMenuRef,
          popover: "",
          class: "m-0 inset-0 h-full w-full max-h-full max-w-full border-none bg-accent text-muted",
          onToggle: onPopoverToggle
        }, [
          _createElementVNode("div", _hoisted_11, [
            _cache[6] || (_cache[6] = _createElementVNode("button", {
              type: "button",
              class: "top-0 right-0 fixed p-8 rounded f-ring-accent",
              popovertarget: "mobile-menu",
              popovertargetaction: "hide"
            }, [
              _createElementVNode("span", {
                class: "menu-icon h-8 w-8 i-ri:close-fill",
                "aria-hidden": "true"
              }),
              _createElementVNode("span", { class: "sr-only" }, " Close mobile navigation menu ")
            ], -1)),
            _createElementVNode("nav", _hoisted_12, [
              _createElementVNode("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (link) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: link.name
                  }, [
                    _createVNode(_component_NuxtLink, {
                      class: _normalizeClass(["underlined-link px-2 py-2", {
                      'not-[:hover,:focus,:active]:after:border-transparent':
                        _ctx.$route.path !== link.path,
                    }]),
                      to: link.path
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(link.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "to"])
                  ]))
                }), 128)),
                _createElementVNode("li", null, [
                  _createVNode(_component_ToggleColorMode, { class: "flex" })
                ])
              ])
            ])
          ])
        ], 544)
      ]),
      _createVNode(_component_ToggleColorMode, { class: "hidden md:flex" })
    ])
  ]))
}
}

})